import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { lenis } from "@/lib/lenis";
import Preloader from "@/components/Preloader";
import WhatsAppButton from "@/components/WhatsAppButton";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Nosotros from "@/pages/Nosotros";
import Servicios from "@/pages/Servicios";
import Metodologia from "@/pages/Metodologia";
import Industrias from "@/pages/Industrias";
import Ecosistema from "@/pages/Ecosistema";
import Contacto from "@/pages/Contacto";
import BolsaDeTrabajo from "@/pages/BolsaDeTrabajo";
import AvisoPrivacidad from "@/pages/AvisoPrivacidad";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Preloader />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/metodologia" element={<Metodologia />} />
          <Route path="/industrias" element={<Industrias />} />
          <Route path="/divisiones" element={<Ecosistema />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/talento" element={<BolsaDeTrabajo />} />
          <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#051323",
            color: "#F7F6F3",
            border: "1px solid rgba(198, 158, 95, 0.4)",
            borderRadius: "2px",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
